import axios from 'axios';

const getFornecedorGrupo = params => axios.get('/fornecedores-gestao-grupos/completo', { params });

export default {
  getFornecedorGrupo,
};
